import { AiFillAppstore } from "react-icons/ai";
import {
  FaGlobe,
  FaDatabase,
  FaCode,
  FaCloud,
  FaPlug,
  FaSitemap,
} from "react-icons/fa";
import { MdAssignmentTurnedIn, MdOutlineSecurity } from "react-icons/md";
import { SiProgress, SiAntdesign } from "react-icons/si";
import { RiTeamLine } from "react-icons/ri";

export const featuresData = [
  {
    id: 1,
    icon: <AiFillAppstore />,
    title: "Application Development",
    des: "Proficient in developing scalable, user-centric web and mobile applications using modern frameworks, with a focus on performance and usability.",
  },
  {
    id: 2,
    icon: <FaCode />,
    title: "Full Stack Development",
    des: "Experienced in end-to-end development, building robust solutions across frontend, backend, and database layers with clean, maintainable code.",
  },
  {
    id: 3,
    icon: <FaDatabase />,
    title: "Database Management",
    des: "Skilled in designing and managing relational and NoSQL databases such as MySQL, MongoDB, and Firebase for efficient data handling.",
  },
  {
    id: 4,
    icon: <MdOutlineSecurity />,
    title: "Role-Based Access Control",
    des: "Implemented secure RBAC systems to manage user permissions and ensure data integrity across applications.",
  },
  {
    id: 5,
    icon: <SiAntdesign />,
    title: "User Experience Design",
    des: "Focused on crafting clean, intuitive interfaces that prioritize user engagement, accessibility, and seamless interaction flows.",
  },
  {
    id: 6,
    icon: <MdAssignmentTurnedIn />,
    title: "Debugging & Optimization",
    des: "Efficient in identifying and resolving performance bottlenecks, bugs, and technical issues to ensure application stability and responsiveness.",
  },
  {
    id: 7,
    icon: <SiProgress />,
    title: "SEO Optimization",
    des: "Applied best practices to improve search engine visibility, enhance organic reach, and drive targeted traffic to web platforms.",
  },
  {
    id: 8,
    icon: <FaGlobe />,
    title: "Web Hosting & Deployment",
    des: "Experienced in deploying and maintaining applications on scalable hosting environments with a focus on uptime, security, and CI/CD.",
  },
  {
    id: 9,
    icon: <RiTeamLine />,
    title: "Agile & Team Collaboration",
    des: "Collaborated in cross-functional teams using Agile methodologies, version control systems, and task management tools for smooth development cycles.",
  },
  {
    id: 10,
    icon: <FaCloud />,
    title: "DevOps & Cloud Infrastructure",
    des: "Automating cloud infrastructure on AWS/Azure with Docker, Kubernetes, Terraform, and Jenkins. Proficient in monitoring with Prometheus/Grafana/ELK and scripting automation with Python and Bash.",
  },
  {
    id: 11,
    icon: <FaPlug />,
    title: "API Development & Integration",
    des: "Skilled in designing, building, and securing RESTful APIs and GraphQL endpoints for seamless data exchange between services and client applications.",
  },
  {
    id: 12,
    icon: <FaSitemap />,
    title: "Microservices Architecture",
    des: "Experienced in designing and implementing scalable, resilient microservices architectures, enabling independent deployment and management of complex systems.",
  },
];
